import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { RestApi } from '../RestApi/restApi';
import { Observable } from 'rxjs';

interface Lifecycle {   
  statusMessage: any;
  error: boolean;
  data: any[];
}
interface commonResponse {
  statusMessage: any;
  error: boolean;
  data: any[];
  workflowid;
  attributes
}

@Injectable({
  providedIn: 'root'
})
export class LifecycleService {

   private headers = new HttpHeaders({
      "Content-Type": "application/json"
      });

    constructor(
      private http: HttpClient,
      private snackBar: MatSnackBar,
      private spinner: NgxUiLoaderService,
      private restAPI: RestApi,
      private router: Router
    ) { }
  
    createLifecycle(lifecycleRequestDto: any):Observable<any>  {
      return this.http.post<Lifecycle>(this.restAPI.CREATE_LIFECYCLE_CONFIGURATION, lifecycleRequestDto, { headers: this.headers });
    }
    getLifecycleDetails(): Observable<Lifecycle> {
      return this.http.get<Lifecycle>(this.restAPI.GET_LIFECYCLE_DETAILS, { headers: this.headers });
    }
  deleteLifecycle(lifecycleId): Observable<Lifecycle> {
    return this.http.delete<Lifecycle>(this.restAPI.DELETE_LIFECYCLE + "/" + lifecycleId, { headers: this.headers });
  }
  
  getWorkflows(): Observable<commonResponse> {
    return this.http.get<commonResponse>(this.restAPI.GET_WORKFLOWS, { headers: this.headers });
  }

  deleteWorkflow(workflowId): Observable<commonResponse> {
    return this.http.delete<commonResponse>(this.restAPI.DELETE_WORKFLOW + "/" + workflowId, { headers: this.headers });
  }

  createWorkflow(workflowRequestDto: any): Observable<commonResponse> {
    return this.http.post<commonResponse>(this.restAPI.CREATE_WORKFLOW, workflowRequestDto, { headers: this.headers });
  } 

   createWorkflowSteps(workflowsteps) {
    return this.http.post<commonResponse> (this.restAPI.CREATE_WORKFLOW_STEPS, workflowsteps,{headers:this.headers},)
  }

  deleteWorkflowSteps(workflowstepid){
    return this.http.delete<commonResponse>(this.restAPI.DELETE_WORKFLOW_STEPS+"/"+workflowstepid,{headers:this.headers})
  }
  retrieveWorkflowSteps(workflowId){
    return this.http.get<commonResponse>(this.restAPI.RETRIEVE_WORKFLOW_STEPS + "/" +workflowId,{headers:this.headers})
  }

  // getWorkflowNextSteps(){
  //   return this.http.get<commonResponse>(this.restAPI.RETIEVE_WORKFLOW_NEXT_STEP_DETAILS )
  // }

  createPlaceholderWorkflowStep(data){
    return this.http.post<commonResponse>(this.restAPI.CREATE_PLACEHOLDER_WORKFLOW_STEP ,data,{headers:this.headers});
  }

  retrieveJSuiteObjectsByWorkflowAndLifecycleId(lifecycleid){
    return this.http.get<commonResponse>(this.restAPI.JSUITE_OBJECTS_BASED_ON_LIFECYCLE + '/'+lifecycleid,{headers:this.headers})
  }

  retrieveLifecycleStatesByWorkflowId(workflowId){
    return this.http.get<commonResponse>(this.restAPI.RETRIEVE_LIFECYCLE_STATES_BY_WORKFLOW_ID + "/" +workflowId,{headers:this.headers}) 
  }   
  
  getLifecycleAndStatesDetails(objectName): Observable<any[]> {
    return this.http.get<any[]>(this.restAPI.GET_LIFECYCLE_AND_STATES + "/" + objectName, { headers: this.headers });
  }
}
